import React from 'react';
import styled from 'styled-components';
import * as icons from '@boxine/tonies-ui/icons';
import { useTranslation } from 'react-i18next';
import { useIsMobileNavigation } from '../hooks/useIsMobileNavigation';
import { FocusStyles } from '../../../styles/FocusStyles';
import Icon from '../../Icon';
import { HEIGHT_VIEWBOX_LARGE_SWUNG_IN_PX, HEIGHT_VIEWBOX_SMALL_SWUNG_IN_PX, } from './SwungBorder';
const MobileWrapper = styled.div `
  background: ${props => props.theme.White};
  display: ${props => (props.isOpen ? 'block' : 'none')};
  padding-bottom: 4rem;
  padding-top: 2rem;
  position: absolute;
  right: 0;
  left: 0;
  bottom: 0;
  top: ${HEIGHT_VIEWBOX_SMALL_SWUNG_IN_PX}px;

  width: 100vw;
  overflow: auto;
  /* Show under header bar */
  z-index: 1;

  /* Fix for padding-bottom not respected by overflow: auto */
  &:after {
    content: '';
    display: block;
    height: 3.125rem;
    width: 100%;
  }
`;
const DesktopWrapper = styled.div `
  background: ${props => props.theme.MetaNavBackground};
  border-radius: 100px;
  border-radius: 0 0 100px 100px / 0% 0% 100% 100%;
  height: 5.5rem;
  left: 50%;
  transform: translateX(-50%);
  position: absolute;
  top: calc(${HEIGHT_VIEWBOX_LARGE_SWUNG_IN_PX / 16}rem - 1.5rem);
  display: flex;
  padding-top: 0.9rem;
  padding-left: 8rem;
  padding-right: 8rem;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  /* Position under header */
  z-index: -1;
`;
const BackButton = styled.button `
  background: transparent;
  border: none;
  box-sizing: content-box;
  color: ${props => props.theme.BrandPrimary};
  cursor: pointer;
  /* Remove unwanted space when focused */
  display: flex;
  height: 1.5rem;
  left: 1rem;
  padding: 0.5rem;
  position: fixed;
  top: calc(1.5rem + ${HEIGHT_VIEWBOX_SMALL_SWUNG_IN_PX}px);
  width: 1.5rem;

  ${FocusStyles};

  &:hover {
    color: ${props => props.theme.BrandPrimaryHover};
  }

  /* prettier-ignore */
  @supports not (selector(:focus-visible)) {
    &.focus-visible,
    &:focus {
      position: fixed;
    }
  }

  /* prettier-ignore */
  @supports selector(:focus-visible) {
    &:focus-visible {
      position: fixed;
    }
  }
`;
const StyledIcon = styled(Icon) `
  height: 1.5rem;
  width: 1.5rem;
`;
const DesktopList = styled.ul `
  display: grid;
  grid-auto-flow: column;
  grid-gap: 2rem;
`;
export const NestedNavigation = ({ children = null, id = undefined, isOpen = false, onClose = () => undefined, }) => {
    const { t } = useTranslation('MainNavigation');
    const isMobileNavigation = useIsMobileNavigation();
    if (isMobileNavigation) {
        return (React.createElement(MobileWrapper, { id: id, isOpen: Boolean(isOpen) },
            React.createElement(BackButton, { onClick: onClose },
                React.createElement(StyledIcon, { fillAll: "", fill: "", title: t('BackButtonTitle'), type: icons.arrowLeftFill })),
            React.createElement("ul", null, children)));
    }
    else {
        return (React.createElement(DesktopWrapper, null,
            React.createElement(DesktopList, null, children)));
    }
};
